import React, { useState, useEffect, useRef } from 'react';
import CardTooltip from '../../CardTooltip';
import Icon from '../../Icons';
import * as S from './styles';
import * as Styles from '../styles';

function InputTag({ field, onBlur, onChange, minSize = 3, maxSize = 4 }) {
    const inputTag = useRef(null);
    const [dataSelected, setDataSelected] = useState(field.value || []);
    const [iconAdd, setIconAdd] = useState(false);

    useEffect(() => {
        setDataSelected(field.value || []);
    }, [field.value]);

    function handleChange(event) {
        const { value } = event.target;
        setIconAdd(value.length >= minSize && value.length <= maxSize);
    }

    function handleBlur() {
        const listValues = dataSelected.length > 0 ? dataSelected : false;
        if (typeof onBlur === 'function') onBlur({ target: { id: field.id, value: listValues } });
    }

    function deleteTag(value) {
        const filteredValues = dataSelected.filter((item) => item.codigoInternacionalDoenca !== value);

        setDataSelected(filteredValues);

        if (typeof onChange === 'function') onChange({ id: field.id, value: filteredValues });
    }

    function addTagOption() {
        const { value } = inputTag.current;
        const valueTrim = value.trim();
        if (valueTrim === '' || valueTrim.length < minSize || valueTrim.length > maxSize) return;

        const tag = { codigoInternacionalDoenca: value.toUpperCase() };
        let listValues = [...dataSelected];

        const idx = dataSelected.findIndex((o) => o.codigoInternacionalDoenca.toUpperCase() === value.toUpperCase());
        if (idx === -1) {
            listValues = [...dataSelected, tag];
            setDataSelected(listValues);
        }

        inputTag.current.value = '';
        setIconAdd(false);

        if (typeof onChange === 'function') onChange({ id: field.id, value: listValues });
    }
    return (
        <Styles.FormGroup>
            <label htmlFor="first-label">
                {field.label && `${field.label} ${!field.required && !field.disabled ? ' (opcional)' : ''}`}
                {field.help && (
                    <CardTooltip message={field.help}>
                        <Styles.ContainerHelp>
                            <Icon name="info" size={18} />
                        </Styles.ContainerHelp>
                    </CardTooltip>
                )}
            </label>
            <S.ContainerInput className={`${field.error ? 'error' : ' '} ${field.disabled ? 'disabled' : ' '}`}>
                <S.StyledInput
                    disabled={field.disabled}
                    ref={inputTag}
                    minLength={minSize}
                    maxLength={maxSize}
                    id={field.id}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={field.placeholder}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            addTagOption();
                        }
                    }}
                />
                {iconAdd && (
                    <div onClick={() => addTagOption()} className="icon-container">
                        <span className="material-icons-outlined">add_circle</span>
                    </div>
                )}
            </S.ContainerInput>
            {field.error && <Styles.SpanError>{field.error}</Styles.SpanError>}
            {dataSelected && (
                <S.ContainerTag>
                    {dataSelected.map((el, i) => (
                        <div key={`${el.codigoInternacionalDoenca}-${i}`}>
                            {el.codigoInternacionalDoenca.toUpperCase()}
                            <Icon onClick={() => deleteTag(el.codigoInternacionalDoenca)} name="close" />
                        </div>
                    ))}
                </S.ContainerTag>
            )}
        </Styles.FormGroup>
    );
}

export default InputTag;
